export const ProductListingGroup = {
  parent: 'AssetGroup',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Asset Group Listing Group',
    },
    AssetGroupId: {
      'bulk-upload-header': 'Parent ID',
    },
    ParentId: {
      'bulk-upload-header': 'Parent Listing Group Id',
    },
    IsExcluded: {
      'bulk-upload-header': 'Is Excluded',
    },
    IsLeaf: {
      'bulk-upload-header': 'Sub Type',
      'bulk-upload-mapper': function (value) {
        if (value) {
          return 'Unit';
        }
        return 'Subdivision';
      },
    },
    Status: {
      'bulk-upload-header': 'Status',
      'bulk-upload-mapper': function (value) {
        if (value === 'Deleted') {
          return 'Deleted';
        }
        return 'Active';
      },
    },
  },
};
